// Public one-page marketing site. Sections per the brief, in order:
//   Hero → The Flip → The Arc → The Work → The Proof → Packages → Fry Cooks → CTA
// Other nav items (Events Calendar, Watch Live, Shop, Get a Quote) are top-level
// routes — handled in App.js.
import SiteNav from "./components/SiteNav";
import Hero from "./Hero";
import TheFlip from "./sections/TheFlip";
import TheArc from "./sections/TheArc";
import TheWork from "./sections/TheWork";
import TheProof from "./sections/TheProof";
import Packages from "./sections/Packages";
import FryCooks from "./sections/FryCooks";
import CtaFinal from "./sections/CtaFinal";
import SiteFooter from "./sections/SiteFooter";

export default function Home({ navigate }) {
  return (
    <div style={{ background: "#0e2e46", minHeight: "100vh" }}>
      <SiteNav />
      <Hero />
      <TheFlip />
      <TheArc />
      <TheWork navigate={navigate} />
      <TheProof />
      <Packages />
      <FryCooks />
      <CtaFinal />
      <SiteFooter />
    </div>
  );
}
